<template id="main">
    <div>
        <Banner></Banner>
        <LoginVerify></LoginVerify>
    </div>
</template>

<script>
// import Title from "@/components/Title";
import Banner from "@/components/Banner";
// import Industry from "@/components/Industry";
// import Opinion from "@/components/Opinion";
// import Cooperation from "@/components/Cooperation";
// import Judge from "@/components/Judge";
// import Nav from "@/components/Nav";
import LoginVerify from "@/components/LoginVerify";
export default {
    components: {
        // Title,
        Banner,
        // Industry,
        // Opinion,
        // Cooperation,
        // Judge,
        // Nav,
        LoginVerify
    },
    data() {
        return {
            // judgeTitle: pageDatas.judgeDatas.titleArr,
            // judgeDatas: pageDatas.judgeDatas.datas,
            // NavDatas: pageDatas.navDatas.datas,
            // name:sessionStorage.getItem("name")
        };
    },
    metaInfo() {
        return {
            title: this.pageName
        };
    },
    created() {
        this.detection();
    },
    methods:{
        detection(){
            let name = sessionStorage.getItem("name");
            // alert(name);
            if(name){
                this.$router.push({ path: "home" });
            }
        }
    }

};
</script>
<style lang="scss">
@import "../scss/main.scss";
</style>